import { NavigationProp, useNavigation } from "@react-navigation/native";

import { InlineDatePicker } from "@whoosh/design-system/src/components/controls/Datepickers";
import {
  generateDateInfo,
  getParsedDateObj,
} from "@whoosh/design-system/src/components/controls/Datepickers/components/Calendar/utils/calendarDateUtils";
import { NumericalDayOfWeek } from "@whoosh/utilities/src/calendars";

import { ClubStackNavigatorParamList } from "../../../../navigators/ClubNavigator";
import { markSelectedDate } from "./utils/markSelectedDate";

type AgendaDateSelectorControlInnerProps = {
  startDate: string;
  endDate: string;
  selectedDate: string;
  onChange?: (date: string) => void;
  clubWeekStartsOn: NumericalDayOfWeek;
};

export const AgendaDateSelectorControlInner = ({
  startDate,
  endDate,
  selectedDate,
  onChange,
  clubWeekStartsOn,
}: AgendaDateSelectorControlInnerProps) => {
  const navigation =
    useNavigation<NavigationProp<ClubStackNavigatorParamList, "Agenda">>();

  const handleChange = onChange
    ? onChange
    : (date: string) => {
        navigation.setParams({
          date,
        });
      };

  const dateInfo = markSelectedDate(
    generateDateInfo(
      getParsedDateObj(startDate, clubWeekStartsOn),
      getParsedDateObj(endDate, clubWeekStartsOn),
      "Available"
    ),
    selectedDate
  );

  return (
    <InlineDatePicker
      startDate={startDate}
      endDate={endDate}
      onSelectDate={handleChange}
      selectedDate={selectedDate}
      fillEmptyDays
      showDayOfWeekHeader
      dateInfo={dateInfo}
      clubWeekStartsOn={clubWeekStartsOn}
    />
  );
};
